import * as React from "react";
import Box from "@mui/material/Box";

import dayjs from 'dayjs';
import {Button} from "@mui/material";
import axios from "axios";
import {getUrl} from "../../requests";
import {useEffect,  useState} from "react";
import {AreaAddedReportRow} from "./AreaAddedReportRow";
import DateRangePicker from '../DateRangePicker';
import {WarningInfo, WarningInfoState} from "../../Components/UI/Info/WarningInfo";
import {SuccessInfo, SuccessInfoState} from "../../Components/UI/Info/SuccessInfo";
import {ErrorInfo, ErrorInfoState} from "../../Components/UI/Info/ErrorInfo";
import {DEF} from "../../const";
import {Libs} from "../../App/libs";
import css from "./AreaReport.module.css";
import clsx from "clsx";


export const  AreaReport = (props) => {
    const [dateFrom, setDateFrom] = useState(props?.dateFrom ? props.dateFrom : dayjs(new Date()).add(-2, "month").toDate());
    const [dateTo, setDateTo] = useState(props?.dateTo ? props?.dateTo : new Date());

    const [messageState, setMessageState] = useState(SuccessInfoState);
    const [errorState, setErrorState] = useState(ErrorInfoState);
    const [warningState, setWarningState] = useState(WarningInfoState);
    const [dateError, setDateError] = useState("");

    const [areasReport, setAreasReport] = useState([]);
    const [isInitialized, setIsInitialized] = useState(false);
    const [disableReport, setDisableReport] = useState(false);
    const [disableReportToDisk, setDisableReportToDisk] = useState(true);
    const [disableReportToGoogle, setDisableReportToGoogle] = useState(true);

    useEffect(() => {
        if(dateError) {
            setErrorState(errorState => ({...errorState, msg: dateError}));
            setDateError('');
        }
    }, [dateError]);

    useEffect(() => {
        if (isInitialized) {
            setMessageState(messageState => ({...messageState, msg: ''}));
            setDisableReportToDisk(true);
            setDisableReportToGoogle(true);
            setAreasReport([]);
        }
        setIsInitialized(true);
    }, [dateFrom, dateTo]);

    const getJson = async () => {
        setAreasReport([]);
        setMessageState(messageState => ({...messageState,
            msg: 'Generowanie raportu...',
            show: DEF.POPUP_SHOWING_INFINITE_TIME
        }));

        try {
            const request = {
                headers: {
                    Authorization: `Bearer ${props.auth?.user}`,
                },
                params: {
                    dateFrom: dayjs(dateFrom).format(DEF.DATE_FORMAT),
                    dateTo: dayjs(dateTo).format(DEF.DATE_FORMAT),
                }
            };

            const response = await axios.get(`${getUrl()}/api/v1/reports/uploaded-areas-json`, request);

            if (response.status === 200 && Array.isArray(response.data)) {
                if (response.data.length > 0) {
                    setMessageState(messageState => ({...messageState,
                        msg:'Pobranych rekordów: ' + response.data.length,
                        show: DEF.POPUP_SHOWING_DEFAULT_TIME
                    }));
                    setDisableReportToDisk(false);
                    setDisableReportToGoogle(false);
                    setAreasReport(response.data);
                } else {
                    setMessageState(messageState => ({...messageState, msg: ''}));
                    setWarningState(warningState => ({...warningState, msg: 'Brak danych.'}));
                }
            } else {
                const error = Libs.handleError(response);
                console.error(error);
                setMessageState(messageState => ({...messageState, msg: ''}));
                setErrorState(errorState => ({...errorState, msg: error.message}));
            }

        } catch (ex) {
            const error = Libs.handleError(ex);
            console.error(error);
            setMessageState(messageState => ({...messageState, msg: ''}));
            setErrorState(errorState => ({...errorState, msg: error.message}));
        }
    };

    const getCsvFile = async () => {
        const dF = dayjs(dateFrom).format(DEF.DATE_FORMAT);
        const dT = dayjs(dateTo).format(DEF.DATE_FORMAT);
        const fileName = `uploaded-areas-${dF}-${dT}.csv`;
        setMessageState(messageState => ({...messageState,
            msg: 'Pobieranie raportu...',
            show: DEF.POPUP_SHOWING_INFINITE_TIME,
        }));

        try {
            const request = {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${props.auth?.user}`,
                    },
                    params: {
                        dateFrom: dF,
                        dateTo: dT,
                    }
                };
            const response = await axios.get(`${getUrl()}/api/v1/reports/uploaded-areas-csv`, request);
            if(response.status === 200 )
            {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const link = document.createElement('a');
                    link.href = reader.result;
                    link.download = fileName;

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                };
                reader.readAsDataURL(new Blob([response.data], { type: 'text/csv' }));

                setMessageState(messageState => ({...messageState,
                    msg: 'Pobrano plik na dysk. ' + fileName,
                    show: DEF.POPUP_SHOWING_DEFAULT_TIME,
                }));
            } else {
                setErrorState(errorState => ({...errorState, msg: 'Błąd podczas pobierania pliku: ' + fileName,}));
                setMessageState(messageState => ({...messageState, msg: ''}));
            }
        } catch (ex) {
            console.error(ex);
            setErrorState(errorState => ({...errorState, msg: 'Błąd podczas pobierania pliku: ' + fileName,}));
            setMessageState(messageState => ({...messageState, msg: ''}));
        }
    }

    const saveCsvToGDrive = async () => {
        const dF = dayjs(dateFrom).format(DEF.DATE_FORMAT);
        const dT = dayjs(dateTo).format(DEF.DATE_FORMAT);
        const fileName = `uploaded-areas-${dF}-${dT}.csv`;

        setMessageState(messageState => ({...messageState,
            msg: 'Przesyłanie raportu na Dysk Google...',
            show: DEF.POPUP_SHOWING_INFINITE_TIME,
        }));

        try {
            const request = {
                headers:
                {
                    Authorization: `Bearer ${props.auth?.user}`,
                },
                params :
                {
                    dateFrom: dF,
                    dateTo: dT,
                }
            };

            const response = await axios.get(`${getUrl()}/api/v1/reports/uploaded-areas-csv-to-gdrive`, request);

            if (response.status === 200) {
                const link = <a href={response.data}
                                target="_blank"
                                rel="noopener noreferrer">Otwórz: {fileName}
                             </a>;

                setMessageState( messageState => ({...messageState,
                    msg: link,
                    show: DEF.POPUP_SHOWING_MANUAL_CLOSE,
                }));
            } else {
                console.error('Nie udało się wygenerować raportu.', response.status , response.data);
                setMessageState(messageState => ({...messageState, msg: ''}));
                setErrorState(errorState => ({...errorState,
                    msg:"Błąd podczas zapisywania pliku na gdrive: " + fileName,
                    show: DEF.POPUP_SHOWING_MANUAL_CLOSE
                }));
            }
        } catch (ex) {
            console.error(ex);
            setErrorState(errorState => ({...errorState,
                msg:"Błąd podczas zapisywania pliku na gdrive: " + fileName,
                show: DEF.POPUP_SHOWING_MANUAL_CLOSE
            }));
            setMessageState(messageState => ({...messageState, msg: ''}));
        }
    }

    return (
        <Box className={clsx(css.areaReport)}>
            <Box className={clsx(css.controlPanel, 'controlPanel')}>
                <DateRangePicker
                    setDateFrom={setDateFrom}
                    setDateTo={setDateTo}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    setDateError={setDateError}
                    inputFormat='YYYY-MM-DD'
                    mask='____-__-__'
                />

                <Button id='new-area-report-btn-get-json' className='button'
                        variant="contained"
                        disabled={disableReport}
                        onClick={getJson}>
                    generuj<br/>raport
                </Button>

                <Button id='new-area-report-btn-get-csv' className='button'
                        variant="contained"
                        disabled={disableReportToDisk}
                        onClick={getCsvFile}
                >
                    plik na <br/>dysk
                </Button>

                <Button id='new-area-report-btn-csv-to-gdrive' className='button'
                        variant="contained"
                        disabled={disableReportToGoogle}
                        onClick={saveCsvToGDrive}
                >
                    plik na <br/> google
                </Button>
            </Box>

            {errorState.msg && <ErrorInfo state={errorState} setState={setErrorState}/>}
            {warningState.msg && <WarningInfo state={warningState} setState={setWarningState}/>}
            {messageState.msg && <SuccessInfo state={messageState} setState={setMessageState}/>}

            <Box className={clsx(css.scrollable, 'scrollable')}>
                {areasReport.length > 0 && (
                    areasReport.map((area, index) => (
                        <Box key={index} mt={0.5}>
                            <AreaAddedReportRow
                                epid={area.epid}
                                date={area.insertDate}
                                rowsTotal={area.rowsTotal}
                                rowsLoaded={area.rowsLoaded}
                                key={index}
                            />
                        </Box>
                    ))
                )}
            </Box>
        </Box>

    );
}

export default AreaReport;


